import React, { Component } from "react";
import { Link } from 'react-router-dom'
import dotenv from 'dotenv';
import Helper from '../DevServices/Helper'
import { Redirect } from 'react-router-dom';
import { connect } from "react-redux";
import { compose } from "redux";
import { 
    //thunkTest,
    t_api_req_device_list_by_user_role,
    t_get_sensors_collection_by_id,
    t_get_sensor_data_30m_by_selectedDevId_sensorId_for_modal,
    update_sensor_collections,
} from "../../reducers/dev";
import UnatedDataTable from "./UnitedDataTable"
import CardList from "./CardList"
//import Xd from "./Xd"
/*
import Helper from "../LocServices/Helper"
import { login } from "../../actions/auth"; */
/* import { reqLocId_findInfo, 

} from "../../reducers/location"; */



dotenv.config();

class PageSensCollection extends Component {
/*   constructor(props) {
    super(props);
    this.handlelocationId = this.handlelocationId.bind(this);
    this.onChangelocationId= this.onChangelocationId.bind(this);

    this.state = {
      //locationId: 0,
      isValidate: false,
      loading: false,
    };
  } */

  componentWillUnmount(){
    //console.log('Good Bye!')
/*     this.props.reset_LocIdInfo() */
  }
  componentDidUpdate(prevProps) {
    // Check if the URL has changed
    
    if (this.props.match.params.collection_id !== prevProps.match.params.collection_id) {
      const rx_collection_id = this.props.match.params.collection_id

      this.props.t_get_sensors_collection_by_id(rx_collection_id) // Fetch new data
      
    }
}

  componentDidMount(){
    //if (this.props.user) this.props.thunkTest(this.props.user.accessToken)
    if (this.props.user) this.props.t_api_req_device_list_by_user_role()  

    const rx_collection_id = this.props.match.params.collection_id
    //-- process rx data ---
    this.props.t_get_sensors_collection_by_id(rx_collection_id) // Fetch new data
    //console.log(rx_collection_id)  

  }

  refreshData = setInterval(() => {
    this.props.t_get_sensors_collection_by_id(this.props.match.params.collection_id)
    console.log('Refresh data timer. 3s')
}, 1000*60*5); //every 5 min refresh data


  render() {
        // Check if the user is authenticated or exists
        if (!this.props.user) {
          // Redirect to an external URL
          //window.location.href = "https://google.com";
          window.location.href = process.env.REACT_APP_HOST+"/login";
          return null; // Return null to avoid rendering anything else
        }
    //if (this.props.user) return <Redirect to="/login" />;
    //const o = this.props.dev.sensors_collection_id.data_10_days_back.collection_info_by_id

    return (
      <>
    <div className="container mt-5">
    <h3 className="text-info">Device Collection #{this.props.dev.sensors_collection_id.id}</h3>
    <div className="card-text text-info">{this.props.dev.sensors_collection_id.description}</div>
    <CardList
       dev_id_with_name = {this.props.dev.sensors_collection_id.data_10_days_back.dev_id_with_name}
      />

    <UnatedDataTable 
      data_10_days_back= {this.props.dev.sensors_collection_id.data_10_days_back}
      t_get_sensor_data_30m_by_selectedDevId_sensorId_for_modal = {this.props.t_get_sensor_data_30m_by_selectedDevId_sensorId_for_modal}
      update_sensor_collections = {this.props.update_sensor_collections}
      isModal = {this.props.dev.sensors_collection_id.isModal}
      modalTitle = {this.props.dev.sensors_collection_id.modalTitle}
      sensor_data_for_modal = {this.props.dev.sensors_collection_id.sensor_data_for_modal}
    />

      <hr />

      {/* <Helper props={this.props.dev} /> */}
      <Helper props={this.props.dev.sensors_collection_id} />

      
    </div>



</>

    );
  }
}

function mapStateToProps(state) {
  //console.log(state)
  const { user, test } = state.auth;

  return {
    user,
    test,
    dev: state.dev,
/*    location: state.location */
  };
}

  const mapDispatchToProps = { 
    //thunkTest,
    t_api_req_device_list_by_user_role,
    t_get_sensors_collection_by_id,
    t_get_sensor_data_30m_by_selectedDevId_sensorId_for_modal,
    update_sensor_collections,
  }



export default compose(
  connect(mapStateToProps, mapDispatchToProps)
  //withAuthRedirect
)(PageSensCollection);

